import { render, staticRenderFns } from "./EnumerationFieldReadonly.vue?vue&type=template&id=8801ff0e&scoped=true"
import script from "./EnumerationFieldReadonly.vue?vue&type=script&lang=ts"
export * from "./EnumerationFieldReadonly.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8801ff0e",
  null
  
)

export default component.exports